import { H3 } from '@h3/types';
import { request } from '@h3/request';

/**
 * 加载消息中心页面列表数据
 * @param data 请求参数
 * @return 消息列表数据
 */
export function getMessageList(data: H3.Message.Request.IMessageListModel) {
    return request<H3.Http.Response.H3Response<H3.Message.Response.IMessageListModel>>(
        '/v1/toolkit/internalmessage/list',
        {
            method: H3.Http.MethodType.POST,
            data,
        },
    );
}

/**
 * 标记消息为已读
 * @param data 请求参数
 */
export function readMessage(data: H3.Message.Request.IMessageReadModel) {
    return request<H3.Http.Response.H3Response<H3.Message.Response.IMessageListModel>>(
        '/v1/toolkit/internalmessage/read',
        {
            method: H3.Http.MethodType.POST,
            data,
        },
    );
}

/**
 * 获取各个菜单的消息总数
 * @param categories 请求参数
 */
export function getMessageCount(categories: H3.Message.MessageMenuType[]) {
    return request<H3.Http.Response.H3Response<H3.Message.Response.IMessageCountModel[]>>(
        '/v1/toolkit/internalmessage/count',
        {
            method: H3.Http.MethodType.POST,
            data: {
                categories,
            },
        },
    );
}
